import * as types from './actionTypes';
import { DashboardState } from './types';

const initialState: DashboardState = {
  activityList: [],
  activityDateRangeList: [],
  activityAvgDetails: {
    emailCounts: 0,
    totalAttachments: 0,
    invalidCounts: 0,
    orderorInvoiceCount: 0,
    tmsSuccessCounts: 0,
    tmsFailedCounts: 0,
    tmsResolvedCounts: 0,
    success: 0,
    failed: 0,
    queueCounts: 0,
    avgEmailsProcessingTime: 0,
    avgMlProcessingTime: 0,
    avgTmsProcessingTime: 0,
    mlSuccessCounts: 0,
    mlFailedCounts: 0,
  },
  isLoading: false,
  error: null,
};

const dashboardReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case types.FETCH_DASHBOARD_ACTIVITY_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case types.FETCH_DASHBOARD_ACTIVITY_LIST_SUCCESS:
      return {
        ...state,
        activityList: action.payload,
        isLoading: false,
      };
    case types.FETCH_DASHBOARD_ACTIVITY_LIST_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case types.FETCH_DASHBOARD_DATE_RANGE_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case types.FETCH_DASHBOARD_DATE_RANGE_LIST_SUCCESS:
      return {
        ...state,
        activityDateRangeList: action.payload,
        isLoading: false,
      };
    case types.FETCH_DASHBOARD_DATE_RANGE_LIST_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case types.FETCH_DASHBOARD_AVG_DETAILS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case types.FETCH_DASHBOARD_AVG_DETAILS_SUCCESS:
      return {
        ...state,
        activityAvgDetails: action.payload,
        isLoading: false,
      };
    case types.FETCH_DASHBOARD_AVG_DETAILS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default dashboardReducer;